export const RequestType = {
    RFI: "RFI",
    RFQ: "RFQ",
    OFR: "OFR",
    LOG: "LOG",
    TRK: "TRK",
    TRS: "TRS",
    LGI: "LGI",
    CSI: "CSI",
    WHI: "WHI",
    POL: "POL",
    AUC: "AUC",
    REV: "REV",
    PQT: "PQT"
};

export const  CompanyProfileType = {
    PROCUREMENT: "PROCUREMENT",
    SUPPLIER: "SUPPLIER",
    LOGISTIC: "LOGISTIC",
    TRUCK: "TRUCK"
}